module.exports = __webpack_public_path__ + "static/img/laytap.07ed69d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/laytap.png
// module id = xs6w
// module chunks = 1